import { useMemo } from "react";
import { Input } from "reactstrap";
import useModule from "../../hooks/useModule";
import useFieldMap from "../../hooks/useFieldMap";
import ManageItems from "../ManageItems/ManageItems";

interface Props {
  moduleProp: string;
  handleSelectField: (field: string) => void;
  handleReorderFields: (newOrder: string[]) => void;
  existingFields?: string[];
}

export default function RecordSummarySelect({
  moduleProp,
  handleSelectField,
  handleReorderFields,
  existingFields,
}: Props) {
  const subitemData = useMemo(() => {
    const splitDataSource = moduleProp?.split?.(".");

    if (splitDataSource?.length < 2) return { mod: null, field: null };

    const subitemModule = splitDataSource?.[0];
    const subitemField = splitDataSource?.[1];

    return { mod: subitemModule, field: subitemField };
  }, [moduleProp]);

  const modAPIName = subitemData.mod || moduleProp;

  const { module } = useModule(modAPIName, true); // true passed to ensure we filter out default fields
  const fieldNameMap = useFieldMap(modAPIName, "Name");

  const handleSelect = (e: any) => {
    e.stopPropagation();
    handleSelectField(e.target.value);
  };

  const fields = useMemo(() => {
    if (!module || !module?.Fields) return [];

    if (subitemData.field) {
      const subitemSchema = module?.Fields.find(
        (f) => f?.APIName === subitemData?.field
      );

      return subitemSchema?.SubitemFields ?? [];
    }

    return module?.Fields ?? [];
  }, [module, subitemData.field]);

  return (
    <>
      <h4 className="m-0">Fields Included In Summary</h4>
      <p className="small">
        Select the fields you'd like to include in the summary.
      </p>
      <Input value="" type="select" onChange={handleSelect} className="mb-2">
        <option disabled value="">
          Select a field to add it
        </option>
        {fields.map((f) => {
          return (
            <option
              disabled={existingFields?.includes(f.APIName)}
              value={f.APIName}
              key={f.APIName}
            >
              {f.Name}
            </option>
          );
        })}
      </Input>
      <ManageItems
        items={existingFields || []}
        isStringArray
        itemNameMap={fieldNameMap}
        itemKey={undefined}
        onDelete={({ id }) => handleSelectField(id)}
        onReorder={({ newOrder }) => handleReorderFields(newOrder)}
      />
    </>
  );
}
